import {IntermediatePart} from "../../parts/intermediatePart";
import {getMetadataByDimensions, iStartWith} from "../../../../../misc/utils";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import store from "../../../../../store";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {toggleNotCompatibleView} from "../../../../../actions/selectionFunctions";

export default class ShowerPanCombo extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_pan_combo';
    this.partName = 'Shower Pan';
    this.translateId = "visualizer.bathroom.shower.shower_pan_combo";
    this.visible = true;
    this.isStoneFeature = false;
    this.layerPriority = 8;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShowerPanCombo())
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    shower.showerFloorIsActive = false;
    if (shower.layout && shower.showerTubComboIsActive()) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
  }

  handleClick(ignoreLocked) {
    const showerPanComboParent = this.getParent();
    const shower = showerPanComboParent.getParent();
    super.handleClick(ignoreLocked); // set active item & not in visualizer item

    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }

    if ((shower.showerFloorIsActive || shower.showerTubComboIsActive()) && !window.location.hash.includes("visualizer")) {
      store.dispatch(toggleNotCompatibleView(true));
      return;
    }

    this.applyFeatureIfNotCompatible();

    if (!this.matchesMetaForArrayOfConditions(this.getParent().getArrayOfConditions())) {
      const showerSizeValues = this.metaData["ShowerSize"];
      const showerPanValues = this.metaData["ShowerPan"];

      if (showerSizeValues && showerPanValues) {
        const showerDoorParent = shower.showerDoor;
        const showerDoorsThatFits = showerDoorParent.features.filter(showerDoorFeature => {
          const showerSizeValues2 = showerDoorFeature.metaData["ShowerSize"];
          const showerPanValues2 = showerDoorFeature.metaData["ShowerPan"];
          let showerSizePassed = showerSizeValues2 && showerSizeValues.some(condValue => {
            return showerSizeValues2.some(condValue2 => condValue === condValue2);
          });
          let showerPanPassed = showerPanValues2 && showerPanValues.some(condPanValue => {
            return showerPanValues2.some(condPanValue2 => condPanValue === condPanValue2);
          });
          return showerSizePassed && showerPanPassed
        });
        if (showerDoorsThatFits && showerDoorsThatFits.length) {
          const showerDimensions = getMetadataByDimensions(showerDoorParent.getParent().showerBody.activeFeature.showerDimensions);
          const sameWallFeatures = showerDoorsThatFits.filter((showerDoorsThatFit) => {
            const wallValue = showerDoorsThatFit.metaData["Wall"] || showerDoorsThatFit.metaData["EX L"];
            return wallValue && wallValue.some(val => val === showerDimensions)
          });

          showerDoorParent.activeFeature = sameWallFeatures.length ? sameWallFeatures[0] : showerDoorsThatFits[0];
          showerDoorParent.placeholderFeature = (sameWallFeatures.length ? sameWallFeatures : showerDoorsThatFits).find((feature) => {
            return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
          });
        }
      }
      const showerBodyParent = this.getParent().getParent().showerBody;
      if (showerSizeValues) {
        const showerBodyThatFits = showerBodyParent.features.filter(showerBodyFeature => {
          const showerSizeValues2 = showerBodyFeature.metaData["ShowerSize"];
          return showerSizeValues2 && showerSizeValues.some(condValue => {
            return showerSizeValues2.some(condValue2 => condValue === condValue2);
          });
        });
        if (showerBodyThatFits.length && showerBodyThatFits.every(shBody => shBody.partName !== showerBodyParent.activeFeature.partName)) {
          let showerBodyToSet = showerBodyThatFits.find(shBody => {
            return shBody.showerDimensions === showerBodyParent.activeFeature.showerDimensions
          }) || showerBodyThatFits[0];
          showerBodyParent.showerBodySelectedByUser = true;
          showerBodyParent.activeFeature = showerBodyToSet;
        }
      }
      this.featureClicked();
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    const showerParent = this.getParent();

    if (showerParent.showerTubComboIsActive() || showerParent.showerFloorIsActive) {
      super.hideLayers();
      return;
    }

    if (this.activeFeature && !this.activeFeature.notAvailableInVisualizer
      && this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions(dontFilterByDoorPanMeta) {
    const showerParent = this.getParent();
    const showerSize = showerParent.showerSize();
    let showerDoorType = '';
    const showerDoor = showerParent.showerDoor;
    const showerDoorActiveFeature = showerDoor ? (showerDoor.activeFeature || showerDoor.placeholderFeature) : null;
    if (!dontFilterByDoorPanMeta && showerDoorActiveFeature) {
      const showerPanValues = showerDoorActiveFeature.metaData["ShowerPan"];
      if (showerPanValues) {
        showerDoorType = showerPanValues;
      }
    }

    // console.log('showerDoorType', showerDoorType);
    // const showerDimensions = this.getParent().showerDimensions() === "30X8" ? "Full" : "Half";
    const conditions = [{
      propName: 'ShowerSize',
      propValue: showerSize
    }];
    if (!dontFilterByDoorPanMeta && showerDoorType) {
      conditions.push({
        propName: 'ShowerPan',
        propValue: showerDoorType
      })
    }
    return conditions;
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => !f.notAvailableInVisualizer && f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    let currentShowerPanMetadata = this.activeFeature && this.activeFeature.metaData["ShowerPan"]
      ?  [...this.activeFeature.metaData["ShowerPan"]]
      : null;
    let previousFeature = null;
    if (this.activeFeature) {
      previousFeature = Object.assign({} , this.activeFeature);
    }
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      let featureToSet = null;
      if (currentShowerPanMetadata) {

        let currentColorArrayValue = null;
        const filterGroups = store.getState().filterState.filterGroups;
        const colorGroup = filterGroups.length && filterGroups.find(filterGroup => filterGroup.name === "Color");
        currentColorArrayValue = previousFeature.dbFeature.filterValueIDs
          && previousFeature.dbFeature.filterValueIDs[colorGroup.id];

        const existingPans = filteredFeatures.filter((feature) => {
          return feature.metaData["ShowerPan"] && feature.metaData["ShowerPan"].some((metaValue) => {
            return currentShowerPanMetadata.includes(metaValue)
          })
        });
        featureToSet = currentColorArrayValue
          ? existingPans.find(filteredFeature => {
            return filteredFeature.dbFeature.filterValueIDs
              && filteredFeature.dbFeature.filterValueIDs[colorGroup.id]
              && filteredFeature.dbFeature.filterValueIDs[colorGroup.id].some(filteredFeatureColor => {
                return currentColorArrayValue.some(col => col === filteredFeatureColor)
              })
          })
          : existingPans[0];
        if (!featureToSet) {
          let filteredByPan = [];
          if (currentShowerPanMetadata.includes("Low Threshold")) {
            filteredByPan = super.getFeaturesWithMeta(filteredFeatures, "ShowerPan", "Designer")
          } else if (currentShowerPanMetadata.includes("Designer")) {
            filteredByPan = super.getFeaturesWithMeta(filteredFeatures, "ShowerPan", "Low Threshold")
          } else if (currentShowerPanMetadata.includes("Custom")) {
            filteredByPan = super.getFeaturesWithMeta(filteredFeatures, "ShowerPan", "Standard");
            if (!filteredByPan.length) {
              filteredByPan = super.getFeaturesWithMeta(filteredFeatures, "ShowerPan", "Made In The USA");
            }
          } else if (currentShowerPanMetadata.includes("Standard")) {
            filteredByPan = super.getFeaturesWithMeta(filteredFeatures, "ShowerPan", "Custom");
            if (!filteredByPan.length) {
              filteredByPan = super.getFeaturesWithMeta(filteredFeatures, "ShowerPan", "Made In The USA");
            }
          } else if (currentShowerPanMetadata.includes("Made In The USA")) {
            filteredByPan = super.getFeaturesWithMeta(filteredFeatures, "ShowerPan", "Custom");
            if (!filteredByPan.length) {
              filteredByPan = super.getFeaturesWithMeta(filteredFeatures, "ShowerPan", "Standart");
            }
          }
          if (filteredByPan.length && previousFeature) {

            if (colorGroup && previousFeature.dbFeature.filterValueIDs) {
              const currentColorArrayValue = previousFeature.dbFeature.filterValueIDs[colorGroup.id];
              if (currentColorArrayValue) {
                featureToSet = filteredByPan.find(filteredFeature => {
                  return filteredFeature.dbFeature.filterValueIDs
                    && filteredFeature.dbFeature.filterValueIDs[colorGroup.id]
                    && filteredFeature.dbFeature.filterValueIDs[colorGroup.id].some(filteredFeatureColor => {
                      return currentColorArrayValue.some(col => col === filteredFeatureColor)
                    })
                });
                // console.log('featureToSet', featureToSet);
              }
            }
          }
          if (!featureToSet && filteredByPan.length) {
            featureToSet = filteredByPan[0]
          }
        }
      }
      const placeholderDefault = filteredFeatures.find((feature) => {
        return iStartWith(feature.dbFeature.displayName, 'Shower Pan - Placeholder');
      });
      this.activeFeature = featureToSet || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
    }
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.Custom60in.ShowerPanCombo;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }
}
